/**
 * Language resource for text content.
 * @typedef {Object} TextContent
 * @property {string} pageTitle - Title for the FAQs page.
 * @property {string} typeOfFaq - Label for the type of FAQ.
 * @property {string} question - Label for the question field.
 * @property {string} answer - Label for the answer field.
 * @property {string} addTitle - Title for adding FAQs.
 * @property {string} editTitle - Title for editing FAQs.
 * @property {string} massage - Confirmation message for deleting FAQs.
 * @property {string} text - Text message confirming the deletion of FAQs.
 * @property {string} action - Label for the action column.
 * @property {string} answerPlaceholder - Placeholder for the answer field.
 * @property {string} questionPlaceholder - Placeholder for the question field.
 * @property {string} addFaqs - Text for adding FAQs action.
 * @property {string} faqsDetails - Label for the FAQs details section.
 * @property {string} deleteDocumentText - Confirmation message for deleting FAQs.
 * @property {string} enterContactNo - Label for entering contact number.
 * @property {string} contactNo - Label for contact number field.
 * @property {string} address - Label for address field.
 * @property {string} enterAddress - Label for entering address.
 * @property {string} emailPlaceholder - Placeholder for email address field.
 * @property {string} privacyPolicy - Label for privacy policy.
 * @property {string} termsAndConditions - Label for terms and conditions.
 * @property {string} contactUs - Label for contact us.
 * @property {string} faq - Label for FAQs.
 */

/**
 * Language resource for text content.
 * @type {TextContent}
 */

export const text = {
    pageTitle: "User Nutrition Logs",
    historyType: "History Type",
    logType: "Log Type",
    userName: "User Name",
    foodImage: "Food Image",
    pageDetailTitle: "User Nutrition details",
};
